import React from "react";
import "./loaders.css";

/**
 * Base shimmer skeleton primitive. All other skeleton loaders compose this.
 */
const Skeleton = ({
  width = "100%",
  height,
  circle = false,
  className = "",
  style = {},
}) => (
  <span
    className={`xc-skeleton ${circle ? "xc-skeleton--circle" : ""} ${className}`.trim()}
    style={{ width, height, ...style }}
    aria-hidden="true"
  />
);

export default Skeleton;
